import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FrequencyCharts } from "./analytics/FrequencyCharts";
import { HotColdCards, OverdueCard, PairsCard } from "./analytics/StreakCards";
import { DistributionsCard } from "./analytics/DistributionsCard";

const ENDPOINTS = ["/stats/frequency", "/stats/hot-cold", "/stats/overdue", "/stats/summary", "/stats/pairs"];

export function Analytics() {
  const [stats, setStats] = useState({});

  useEffect(() => {
    Promise.all(ENDPOINTS.map((p) => api.get(p)))
      .then(([f, h, o, s, p]) => setStats({ freq: f.data, hc: h.data, od: o.data, sum: s.data, pairs: p.data }))
      .catch((e) => console.warn("Analytics failed to load", e?.response?.status));
  }, []);

  const { freq, hc, od, sum, pairs } = stats;

  return (
    <section id="analytics" className="px-4 sm:px-8 lg:px-12 py-12 max-w-[1400px] mx-auto">
      <div className="mb-8">
        <div className="label-caps text-oracle">Terminal</div>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl mt-1 tracking-tight text-parchment">
          The <span className="italic text-oracle">Analytics</span> Floor
        </h2>
        <p className="font-body text-parchment/60 text-sm mt-2 max-w-2xl">
          {freq ? `${freq.total_draws} draws analyzed.` : "Loading…"} Distributions, hot/cold streaks, overdue gaps, and pair co-occurrence.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 sm:gap-6">
        <FrequencyCharts freq={freq} />
        <HotColdCards hc={hc} />
        <OverdueCard od={od} />
        <DistributionsCard sum={sum} />
        <PairsCard pairs={pairs} />
      </div>
    </section>
  );
}
